/*
 * QUEST SOFTWARE PROPRIETARY INFORMATION
 *
 * This software is confidential.  Quest Software Inc., or one of its
 * subsidiaries, has supplied this software to you under terms of a
 * license agreement, nondisclosure agreement or both.
 *
 * You may not copy, disclose, or use this software except in accordance with
 * those terms.
 *
 *
 * Copyright 2026 Quest Software Inc.
 * ALL RIGHTS RESERVED.
 *
 * QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
 * WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
 * TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE, OR
 * NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
 * AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
 * THIS SOFTWARE OR ITS DERIVATIVES.
 */

import { SubscriptionsInfo } from "@foglight/angular-common";

export interface DateFormatConstants {
  default: string;
}

export const dateFormatConstants = {
  default: 'YYYY-MM-DD HH:mm:ss',
};

export interface SubscriptionData {
  subscriptions: SubscriptionsInfo[];
}

export const userEndpoint = '/aui/api/v1/portal/user';
export const productEndpoint = '/aui/api/v1/portal/product';
export const saasAddendumEndpoint =
  '/api/v1/foglight-cloud/legal/saas-addendum/acceptance';
export const globalSearchEndpoint = '/aui/api/v1/portal/global-search';
export const downloadsEndpoint = '/aui/api/v1/portal/downloads/installers';